// Allow dependency injection for metrics module (for testing)
// Return the promise for testability
const reportWebVitals = (onPerfEntry, metricsModule) => {
  if (typeof onPerfEntry === 'function') {
    const metricsPromise = metricsModule
      ? Promise.resolve(metricsModule)
      : import('web-vitals');
    return metricsPromise.then((metrics) => {
      if (metrics && typeof metrics.getCLS === 'function') metrics.getCLS(onPerfEntry);
      if (metrics && typeof metrics.getFID === 'function') metrics.getFID(onPerfEntry);
      if (metrics && typeof metrics.getFCP === 'function') metrics.getFCP(onPerfEntry);
      if (metrics && typeof metrics.getLCP === 'function') metrics.getLCP(onPerfEntry);
      if (metrics && typeof metrics.getTTFB === 'function') metrics.getTTFB(onPerfEntry);
    });
  }
  // Return resolved promise for test consistency
  return Promise.resolve();
};

export default reportWebVitals;
